import { Directive, EmbeddedViewRef, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { VersionCheckerService } from 'src/app/shared/services/version-checker.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
/**
 * The version checker could be started in app.component, but would require injection
 * and app.component already has too many dependencies. As a directive that is avoided.
 */

@UntilDestroy()
@Directive({
    selector: '[ayaVersionChecker]',
    standalone: true
})
export class VersionCheckerDirective implements OnInit {
    view: EmbeddedViewRef<unknown>;

    constructor(
        private readonly templateRef: TemplateRef<unknown>,
        private readonly viewContainer: ViewContainerRef,
        private readonly versionChecker: VersionCheckerService
    ) {}

    ngOnInit() {
        this.viewContainer.clear();
        this.versionChecker.timedVersionPoll.pipe(untilDestroyed(this)).subscribe(({ newVersion }) => {
            this.viewContainer.clear();
            if (newVersion) {
                this.view = this.viewContainer.createEmbeddedView(this.templateRef);
            }
        });
    }
}
